import axios from 'axios';

const resolveApiBaseUrl = () => {
    if (process.env.REACT_APP_API_BASE_URL) {
        return process.env.REACT_APP_API_BASE_URL;
    }

    if (typeof window !== 'undefined' && window.location.hostname.endsWith('ebaydle.com')) {
        return 'https://api.ebaydle.com';
    }

    return 'http://localhost:5000';
};

export const API_BASE_URL = resolveApiBaseUrl();
const API = axios.create({ baseURL: API_BASE_URL });

export interface ProductWithPrice extends Product {
    price_original: number;
}

export interface ProductPriceResponse {
    price: number;
    displayPrice: string;
}

export interface CategorySummary {
    category: string;
    imageUrl: string;
}

export interface SellerDetails {
    name?: string;
    url?: string;
    profile_photo_url?: string;
    join_date?: string;
    feedback_summary?: string;
    about?: string;
    detailed_ratings?: Record<string, string>;
    popular_categories?: string[];
}

export interface Product {
    name: string;
    url: string;
    photos: string[];
    seller_name: string;
    category: string;
    category_path: string[];
    seller_url?: string;
    seller_details?: SellerDetails;
    description_url?: string;
    features?: Record<string, string>;
    daily_challenge_date?: string;
    daily_challenge_datetime?: string;
    daily_challenge_source?: string;
    _id: string;
}

export const getProducts = () => API.get<ProductWithPrice[]>('/products')
export const getProduct = (category?: string) => API.get<Product>('/rand_product', {
    params: category ? { category } : undefined
})
export const getDailyProduct = (date?: string) => API.get<Product>('/daily-product', {
    params: date ? { date } : undefined
})
export const getProductPrice = (productID: string) => API.post<ProductPriceResponse>('/getPrice', {productID});
export const getCategories = () => API.get<CategorySummary[]>('/categories');

export const getCanonicalImageUrl = (imageUrl: string) => {
    const match = imageUrl.match(/https?:\/\/i\.ebayimg\.com\/(?:thumbs\/)?images\/g\/([^/]+)\/s-l\d+\.(?:jpg|jpeg|png|webp)/i);
    if (!match) {
        return imageUrl;
    }

    return `https://i.ebayimg.com/images/g/${match[1]}/s-l1600.webp`;
};

export const normalizeProductPhotos = (photos: string[] = []) => {
    const seen = new Set<string>();

    return photos.reduce<string[]>((normalizedPhotos, photo) => {
        const normalizedPhoto = getCanonicalImageUrl(photo);
        if (!normalizedPhoto || seen.has(normalizedPhoto)) {
            return normalizedPhotos;
        }

        seen.add(normalizedPhoto);
        normalizedPhotos.push(normalizedPhoto);
        return normalizedPhotos;
    }, []);
};

export const getDisplayImageUrl = (imageUrl: string) => {
    try {
        return getCanonicalImageUrl(imageUrl);
    } catch {
        return imageUrl;
    }
};

//export const addProduct = (name: string, price_original: number) => API.post('/', {name, price_original});
